import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useFeatureValue } from '@growthbook/growthbook-react';
import { selectDistributionSlug } from 'selector/navigationSelector';
import { selectMeta } from 'selector/metaSelector';
import { FeatureFlags } from 'config/growthbook/featureFlags';

type RedirectFeatureFlag = {
  distributionSlugs: string[];
  projectIds: string[];
};

export const useDistributionSlugRedirect = () => {
  const distributionSlug = useSelector(selectDistributionSlug);
  const projectId = useSelector(selectMeta)?.getProjectId();

  const redirectFlag = useFeatureValue<RedirectFeatureFlag>(
    FeatureFlags.DISTRIBUTION_SLUG_REDIRECT,
    {
      distributionSlugs: [],
      projectIds: [],
    }
  );

  useEffect(() => {
    if (!distributionSlug || !projectId) {
      return;
    }

    // Check if distributionSlug matches any slug in distributionSlugs
    // or if projectId matches any id in projectIds
    const shouldRedirect =
      redirectFlag.distributionSlugs.includes(distributionSlug) ||
      redirectFlag.projectIds.includes(projectId.toString());

    if (shouldRedirect) {
      location.hostname = location.hostname.replace('-beta', '');
    }
  }, [distributionSlug, projectId, redirectFlag]);
};
